<template>
    <kt-row>
        <kt-col class="col-lg-3 col-md-3 col-sm-6">
            <div class="kt-portlet">
                <div class="kt-portlet__body" style="color: black; background-color: #fff">
                    <h6>{{$t('label.total_benefit')}}</h6>
                    <div class="text-center">
                        <h4 class="fix-margin">
                            {{ statistics.total_profit }}
                            <span style="font-size: 1.5rem">
                                {{' ' + $t('currency.rial')}}
                            </span>
                        </h4>
                    </div>
                </div>
            </div>
        </kt-col>
        <kt-col class="col-lg-3 col-md-3 col-sm-6">
            <div class="kt-portlet">
                <div class="kt-portlet__body" style="color: black; background-color: #fff">
                    <h6>{{$t('label.total_transactions')}}</h6>
                    <div class="text-center">
                        <h4 class="fix-margin">
                            {{ statistics.transactions_sum }}
                            <span style="font-size: 1.5rem">
                                {{' ' + $t('currency.rial')}}
                            </span>
                        </h4>
                    </div>
                </div>
            </div>
        </kt-col>
        <kt-col class="col-lg-3 col-md-3 col-sm-6">
            <div class="kt-portlet">
                <div class="kt-portlet__body" style="color: black; background-color: #fff">
                    <h6>{{$t('label.succeeded_transactions_number')}}</h6>
                    <div class="text-center">
                        <h4 class="fix-margin">
                            {{ statistics.succeeded_trans_count }}
                        </h4>
                    </div>
                </div>
            </div>
        </kt-col>
        <kt-col class="col-lg-3 col-md-3 col-sm-6">
            <div class="kt-portlet">
                <div class="kt-portlet__body" style="color: black; background-color: #fff">
                    <h6> {{ $t('label.last_updated') }}</h6>
                    <div class="text-center">
                        <h5 class="fix-margin">
                            {{ statistics.last_updated }}
                        </h5>
                    </div>
                </div>
            </div>
            <div class="position-absolute" style="left:20px;top:13px;cursor: pointer;">
                <button class="no-border" @click="updateReport()" >
                    <i class="fa flaticon-refresh" aria-hidden="true"
                       style="font-size: 1.6em; color: #0f9af0"
                       :title="$t('label.reportUpdate')"
                    >
                    </i>
                </button>
            </div>
        </kt-col>
    </kt-row>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "transactionStat",
    computed: {
        ...mapGetters('transaction', [
            'statistics'
        ]),
    },
    methods: {
        updateReport() {
            this.$emit('updateReport', {cache: 'clear'})
        }
    }
}
</script>

<style>

</style>